var map = {
	"./thewest-digital-hero-cropped.jpg": 588,
	"./thewest-digital-hero-variation-a-cropped.jpg": 436,
	"./thewest-digital-hero-variation-a.jpg": 589,
	"./thewest-digital-hero-variation-b-cropped.jpg": 590,
	"./thewest-digital-hero-variation-b.jpg": 1099,
	"./thewest-digital-hero-variation-experiment2-cropped.jpg": 591,
	"./thewest-digital-hero-variation-experiment2.jpg": 1100,
	"./thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 592,
	"./thewest-digital-hero-variation-vanishing-cousins.jpg": 1101,
	"./thewest-digital-hero.jpg": 1102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1098;